// @flow

import * as React from 'react';

import { useDispatch } from 'react-redux';

import {
  applications,
  type ApplicationSummary,
} from '@gandi/redux-resource-simplehosting';

import { useAppSelector } from 'src/hooks/useAppSelector';

export function useHostingApplications(): {
  availableApplications: Array<ApplicationSummary>,
  isLoaded: boolean,
  isFetching: boolean,
  isFailure: boolean,
} {
  const dispatch = useDispatch();

  const isLoaded = useAppSelector(applications.selectIsLoaded);
  const isFailure = useAppSelector(applications.selectIsFailure);
  const isFetching = useAppSelector(applications.selectIsFetching);
  const isToRefetch = useAppSelector(applications.selectIsToRefetch);
  const availableApplications =
    useAppSelector(applications.selectSummaries) || [];

  React.useEffect(() => {
    if (((!isLoaded && !isFailure) || isToRefetch) && !isFetching) {
      dispatch(applications.fetch());
    }
  }, [isFailure, isFetching, isLoaded, dispatch, isToRefetch]);

  return {
    availableApplications,
    isFetching,
    isLoaded,
    isFailure,
  };
}
